import isPlainObject from './isPlainObject';
import flattenWhenNode from './flattenWhenNode';
export default flattenWhenNode(isPlainObject);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-blueprint/node_modules/redux-actions/es/utils/flattenActionMap.js
// module id = 2372
// module chunks = 1